<template>
  <div class="tab-view" :class="{ blurred: showPopover }">
    <template v-if="!userStore.user?.referrals.length">
      <div class="tab-title">
        Invite Friends <br />
        Earn Leea Points
      </div>
      <div class="instructions-card">
        <div class="step-title">
          <Number class="step-number">1</Number>
          Send your invitation
        </div>
        <div class="step-description">Get Leea Points and Play Pass for each friend</div>
        <div class="step-divider"></div>
        <div class="step-title">
          <Number class="step-number">2</Number>
          Your friends join Leea
        </div>
        <div class="step-description">And start farming points</div>
        <div class="step-divider"></div>
        <div class="step-title">
          <Number class="step-number number">3</Number>
          Score 10% from friends
        </div>
        <div class="step-description">Plus extra 2.5% from their referrals</div>
      </div>
    </template>
    <template v-else>
      <LeeaCard>
        <template #title> Invite Friends</template>
        <template #description>
          Score 10% from friends. Plus extra 2.5% from their referrals. Get Leea Points and Play
          Pass for each friend.
        </template>
        <template #content>
          <div class="claim-amount">
            {{ userStore.user?.referral_balance }} <IconLP class="lp" />
          </div>
          <LeeaBtn
            :disabled="completed"
            :round="true"
            color="blue"
            width="80px"
            :in-progress="inProgress"
            :completed="completed"
            @click="claim"
            >Claim</LeeaBtn
          >
        </template>
      </LeeaCard>
      <div class="friends-list">
        <div class="friend" v-for="friend of userStore.user?.referrals" :key="friend.id">
          <div>
            <div class="friend-name">{{ friend.name }}</div>
            <div class="friends-count">Invited {{ friend.referrals.length || 0 }}</div>
          </div>
          <div class="friend-points">{{ friend.balance }} <IconLP class="lp" /></div>
        </div>
      </div>
    </template>
    <LeeaBtn @click="showPopover = true">Invite</LeeaBtn>
  </div>
  <Transition name="slide">
    <InvitePopover v-if="showPopover" @close="showPopover = false"> </InvitePopover>
  </Transition>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useUserStore } from '@/stores/user'
import { analyticsService } from '@/services/analytics.service'
import LeeaBtn from '@/components/LeeaBtn.vue'
import LeeaCard from '@/components/LeeaCard.vue'
import Number from '@/components/Number.vue'
import InvitePopover from '@/components/InvitePopover.vue'
import IconLP from '@/components/Icons/IconLP.vue'

const userStore = useUserStore()

userStore.fetchUser()

analyticsService.logTab('Friends')

const showPopover = ref(false)

const inProgress = ref(false)

const completed = computed(() => BigInt(userStore.user!.referral_balance) === 0n)

const claim = async () => {
  inProgress.value = true
  await userStore.claimReferral()
  inProgress.value = false
}
</script>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateY(100%);
}
.slide-enter-to {
  transform: translateY(0);
}
.slide-leave-from {
  transform: translateY(0);
}
.slide-leave-to {
  transform: translateY(100%);
}

.tab-view {
  background: url('@/assets/lines.png') no-repeat;
  background-size: contain;
  background-position: bottom;
  transition: filter 0.5s;
  &.blurred {
    filter: blur(5px);
  }
  .instructions-card {
    border-radius: 25px;
    background: url('@/assets/bg-shapes-small.png'), linear-gradient(#74a3ff, #256fff);
    background-size: cover;
    padding: 25px;
    box-sizing: border-box;
    color: white;
    .step-number {
      margin-right: 10px;
    }
    .step-title {
      font-size: 18px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
    }
    .step-description {
      opacity: 0.8;
    }
    .step-divider {
      margin: 20px 0;
      border-bottom: 1px solid;
      opacity: 0.3;
      height: 0;
      @media(max-height: 600px) {
        margin: 10px 0;
    }
    }
  }
  .leea-btn {
    margin-top: auto;
  }
  .leea-card {
    margin-bottom: 30px;

    @media (max-height: 600px) {
      margin-bottom: 8px;
  }

    .claim-amount {
      font-size: 44px;
      font-weight: 450;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 10px;
      .lp {
        fill: white;
      }
    }
  }
}

.friends-list {
  overflow-y: scroll;
  margin-bottom: 10px;
  .friend {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    &:not(:last-child) {
      border-bottom: 1px solid #e9e9e9;
    }
    .friend-name {
      margin-bottom: 8px;
      font-family: 'Forma DJR Display';
      font-size: 18px;
      letter-spacing: 0.03em;
      font-weight: 700;
    }
    .friend-points {
      font-family: 'Forma DJR Display';
      font-size: 18px;
      letter-spacing: 0.03em;
      font-weight: bold;
      display: flex;
      align-items: center;

      .lp {
        width: 25px;
        height: 25px;
        margin-left: 5px;
      }
    }
    .friends-count {
      font-weight: bold;
      color: var(--gray-dark-color);
    }
  }
}
</style>
